"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSearchPreviewProductSkeleton = exports.StyledQueryListSection = exports.StyledDivider = exports.SectionLabel = exports.SectionHeader = exports.Section = exports.Root = exports.RecentSearchesHeader = exports.Queries = exports.Products = exports.LeftSectionContent = exports.Inner = exports.Columns = void 0;
var _mui = require("@ori-ui/mui");
var _searchPreviewProduct = require("@ori/search-preview-product");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  height: '100%',
  boxSizing: 'border-box',
  overflow: 'auto',
  [theme.breakpoints.up('md')]: {
    overflow: 'hidden'
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  boxSizing: 'border-box',
  height: '100%',
  gap: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    maxHeight: '100%'
  }
}));
const Queries = exports.Queries = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  overflowX: 'auto',
  flexWrap: 'nowrap',
  scrollbarWidth: 'none',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: theme.spacing(3),
  maxWidth: '100%',
  [theme.breakpoints.up('md')]: {
    flexWrap: 'wrap',
    overflowX: 'visible'
  }
}));
const Products = exports.Products = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    paddingRight: theme.spacing(0.5)
  }
}));
const StyledDivider = exports.StyledDivider = (0, _mui.styled)(_mui.Divider)(({
  theme
}) => ({
  backgroundColor: theme.palette.grey[300]
}));
const Section = exports.Section = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(3)
}));
const SectionLabel = exports.SectionLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textTransform: 'uppercase',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold
}));
const SectionHeader = exports.SectionHeader = (0, _mui.styled)('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});
const LeftSectionContent = exports.LeftSectionContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  maxWidth: 300,
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: theme.spacing(6),
  flex: '1 0 0'
}));
const Columns = exports.Columns = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gridTemplateColumns: '300px auto 1fr',
  width: '100%',
  height: '100%',
  gap: theme.spacing(4)
}));
const StyledQueryListSection = exports.StyledQueryListSection = (0, _mui.styled)(_searchPreviewProduct.QueryListSection)({
  [`.${_searchPreviewProduct.queryListSectionClasses.queries}`]: {
    flexWrap: 'wrap'
  },
  [`.${_searchPreviewProduct.queryListSectionClasses.query} > .${_mui.typographyClasses.root}`]: {
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'normal'
  }
});
const StyledSearchPreviewProductSkeleton = exports.StyledSearchPreviewProductSkeleton = (0, _mui.styled)(_searchPreviewProduct.SearchPreviewProductSkeleton)({
  width: '100%'
});
const RecentSearchesHeader = exports.RecentSearchesHeader = (0, _mui.styled)('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
});
